import {
  BackButtonCWUI,
  CustomerCategoryTitleUI,
} from '@next-order/next-order-components';
import React from 'react';
import { useSelector } from 'react-redux';
import VoucherSpecialBox from 'components/VoucherSpecialBox';

export default function VoucherView({
  menuItems,
  showSpecialItem,
  addSpecialToOrder,
  selectedSpecials,
  voucherItem,
  itemExist,
  storeConfig,
  toggleAnimation,
  hideOrder,
  sidebarAnimationClass,
  addToOrder,
  addMultipleToSpecials,
  activeIndex,
  specialBoxes,
  setOrderState,
}) {
  const boxIndex = useSelector(
    (state) => state.homeReducer.voucherFilter.voucherBoxIndex
  );
  const halfHalfSetup = useSelector(
    (state) => state.layoutReducer.halfHalfSetup
  );
  const currentOrder = useSelector((state) => state.homeReducer.currentOrder);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
      className={sidebarAnimationClass}
    >
      <div className='specialViewTopView'>
        <BackButtonCWUI
          extendedClassName='relative -top-1.5'
          onClick={hideOrder}
        />
        <div className='specialViewTop'>
          <span className='voucher'>
            {currentOrder.selectedVoucher.isLoyaltyVoucher
              ? 'Reward'
              : 'Voucher'}
          </span>
        </div>
      </div>

      {currentOrder.selectedVoucher.isLoyaltyVoucher && (
        <CustomerCategoryTitleUI extendedClassName='px-[20px] pt-4'>
          {currentOrder.selectedVoucher.redemptionName || 'Reward'}
        </CustomerCategoryTitleUI>
      )}

      <VoucherSpecialBox
        key={String(toggleAnimation)}
        boxIndex={boxIndex}
        menuItems={menuItems}
        showSpecialItem={showSpecialItem}
        addSpecialToOrder={addSpecialToOrder}
        halfHalfSetup={halfHalfSetup}
        selectedSpecials={selectedSpecials}
        specialItem={voucherItem}
        itemExist={itemExist}
        storeConfig={storeConfig}
        addToOrder={addToOrder}
        addMultipleToSpecials={addMultipleToSpecials}
        activeIndex={activeIndex}
        specialBoxes={specialBoxes}
        setOrderState={setOrderState}
        currentOrder={currentOrder}
        isLoyaltyVoucher={currentOrder.selectedVoucher.isLoyaltyVoucher}
      />
    </div>
  );
}
